import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormControl, FormGroup, InputGroup, Button } from 'react-bootstrap'
import { tableHelper, momentHelper } from './helpers'
import ReportStore from '../../stores/ReportStore'
import Select from 'react-select';
import FontAwesome from 'react-fontawesome';
import { Checkbox, Radio } from 'react-icheck';
import IframeModal from '../../component/element/IframeModal'
import PrintPreview from '../print/PrintPreview';
import Chart from 'chart.js';
import { findDOMNode } from 'react-dom'
import './report.css'

const optionsYear = []
for (var i = momentHelper.getYear(); i >= 2557; i--) {
  optionsYear.push({
    value: i,
    label: i
  });
}

class ReportKKCAllYearIncomeOverview extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading:false,
      year:momentHelper.getYear(),
      data:[],
      displayTb:'',
      displayBar:'none',
      btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>),
      btnAction:'barchart',
      isCost: true,
      isPrice: true,
      affiliates:[]
    }
  }

  componentDidMount(){
    if (this.props.showPrintPreview)
      this.loadData(this.props.year-543)
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year)
    }
  }

  loadData(year=''){
    this.setState({loading:true})
    ReportStore.loadReportAllYearIncomeOverview(year,(result)=>{
      this.setState({data:result.data,affiliates:result.affiliates})
      if (this.props.typePrint==='chart')
        this.setBarChart(true,true)
      else 
        this.setBarChart(this.state.isCost,this.state.isPrice)
    })
  }

  setBarChart(isCost=true,isPrice=true) {
    this.canvasBar = findDOMNode(this.canvasBarRef);
    this.ctxBar = this.canvasBar.getContext('2d');
    let canvasBar = this.canvasBar,ctxBar=this.ctxBar

    let {data,year} = this.state
    let labels = []
    let data_barchart = []
    let data_barchart1 = []
    let data_barchart2 = []
    let data_year = [0,0,0,0,0,0,0,0,0,0,0,0]
    let data_year1 = [0,0,0,0,0,0,0,0,0,0,0,0]
    let data_year2 = [0,0,0,0,0,0,0,0,0,0,0,0]

    let i = 0
    labels = ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม']
    data.forEach(function(item,index) {
      data_year[index] = parseFloat(item.income.amount)
      data_year1[index] = parseFloat(item.expense.amount)
      data_year2[index] = parseFloat(item.balance)

    })
    data_barchart = data_year
    data_barchart1 = data_year1
    data_barchart2 = data_year2

    let checkValue = false
    data_barchart.forEach(function(item,index) {
      if (item>0&&data_barchart1[index]>0&&data_barchart2[index]>0)
        checkValue = true
    })
    
    let ticks = {}
    if ((checkValue)||(isPrice||isCost)) {
      ticks = {
        beginAtZero: true,
        padding: 0,
        callback(value, index) {
          return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        }
      }
    } else {
      ticks = {
        beginAtZero: true,
        padding: 0
      }
    }

    let legend = {onClick: (e) => e.stopPropagation()}
    if (this.props.typePrint==='chart'&&this.props.showPrintPreview)
      legend = {}
    
    let datasets = [{label:'ค่าใช้จ่าย',backgroundColor:'#d9534f',data:data_barchart1},{label:'รายได้',backgroundColor:'#00a65a',data:data_barchart},{label:'คงเหลือ',backgroundColor:'#337ab7',data:data_barchart2}]
    if (isPrice&&!isCost)
      datasets = [{label:'รายได้',backgroundColor:'#00a65a',data:data_barchart},{label:'คงเหลือ',backgroundColor:'#337ab7',data:data_barchart2}]
    else if (!isPrice&&isCost)
      datasets = [{label:'ค่าใช้จ่าย',backgroundColor:'#d9534f',data:data_barchart1},{label:'คงเหลือ',backgroundColor:'#337ab7',data:data_barchart2}]
    else if (!isPrice&&!isCost)
      datasets = [{label:'คงเหลือ',backgroundColor:'#337ab7',data:data_barchart2}]
    
    if(this.barChart!=null){
      this.barChart.destroy();
    }
    this.barChart = new Chart(ctxBar, {
      type: 'bar',
      data: {
          labels: labels,
          datasets: datasets
      },
      options: {
          scales: {
              yAxes: [{
                  ticks: ticks
              }]
          },
          legend: legend
      }
    })
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  onPrintClick() {
    let url = ''
    let type_print = 'report'
    if (this.state.displayBar==='')
      type_print = 'chart'

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage=PrintReportKKCAllYearIncomeOverview&year='+this.state.year+'&type_print='+type_print
    } else{
      url  = './pdf/v2/?startPage=PrintReportKKCAllYearIncomeOverview&year='+this.state.year+'&type_print='+type_print
    }
    this.refs.iframe.loadUrl(url)
  }

  onYearChange(e) {
    this.setState({year:e.value})
    this.loadData(e.value)
  }

  getTotal() {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let income = item.income.customer
      if (income===''||income===null||income===undefined||isNaN(income))
        income = 0

      sum += parseFloat(income)
    })

    return sum
  }

  getSummary(key,sub_key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      let value = item[key]
      if (key!=='balance')
        value = item[key][sub_key]

      if (value===''||value===null||value===undefined||isNaN(value))
        value = 0

      sum += parseFloat(value)
    })

    return sum  
  }

  onBarChartClick(action,e) {
    let {displayTb,displayBar,btnBar,btnAction,year} = this.state
    let new_action = ''
    if (action=='barchart') {
      new_action = 'report'
      this.setState({btnAction:new_action,displayTb:'none',displayBar:'',btnBar:(<div><FontAwesome name='file-text'/>&nbsp;ดูรายงาน</div>)})
      this.loadData(year)
      this.setBarChart(this.state.isCost,this.state.isPrice)  
    } else {
      new_action = 'barchart'
      this.setState({btnAction:new_action,displayTb:'',displayBar:'none',btnBar:(<div><FontAwesome name='bar-chart'/>&nbsp;ดูกราฟแท่ง</div>)})
      this.loadData(year)
    }
  }

  renderToolbar() {
    return(
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.year}
            options={optionsYear}
            style={{width:"80px"}}
            onChange={this.onYearChange.bind(this)}
          />
        </FormGroup>
        &nbsp;
        <FormGroup>
          <Button
            className='btn-primary'
            onClick={this.onBarChartClick.bind(this,this.state.btnAction)}
          >
            {this.state.btnBar}
          </Button>
        </FormGroup>
      </Form>
    )
  }

  renderAffiliates(ditem){
    let {affiliates} = this.state
    return affiliates.map((item,index)=>{
      if(ditem.income[item.affiliates_id]!==undefined){
        return (<td key={index} className='text-right'>{this.getNumberFormat(ditem.income[item.affiliates_id])}</td>)
      }else{
        return (<td  key={index} className='text-right'>0</td>)
      }
    })
  }

  renderRowData() {
    let {data} = this.state
    if (data.length===0) {
      return(<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
          return(
            <tr key={index}>
              <td className='text-center'>{index+1}</td>
              <td>{index===0?'มกราคม':index===1?'กุมภาพันธ์':index===2?'มีนาคม':index===3?'เมษายน':index===4?'พฤษภาคม':index===5?'มิถุนายน':index===6?'กรกฎาคม':index===7?'สิงหาคม':index===8?'กันยายน':index===9?'ตุลาคม':index===10?'พฤศจิกายน':index===11?'ธันวาคม':''}</td>
              <td className='text-right'>{item.income===undefined||item.income.customer===undefined||item.income.customer===null?'':this.getNumberFormat(item.income.customer)}</td>
              {this.renderAffiliates(item)}
              <td className='text-right'>{item.income===undefined||item.income.amount===undefined||item.income.amount===null?'':this.getNumberFormat(item.income.amount)}</td>
              <td className='text-right'>{item.expense===undefined||item.expense.wage===undefined||item.expense.wage===null?'':this.getNumberFormat(item.expense.wage)}</td>
              <td className='text-right'>{item.expense===undefined||item.expense.part===undefined||item.expense.part===null?'':this.getNumberFormat(item.expense.part)}</td>
              <td className='text-right'>{item.expense===undefined||item.expense.part_midmonth===undefined||item.expense.part_midmonth===null?'':this.getNumberFormat(item.expense.part_midmonth)}</td>
              <td className='text-right'>{item.expense===undefined||item.expense.cash===undefined||item.expense.cash===null?'':this.getNumberFormat(item.expense.cash)}</td>
              <td className='text-right'>{item.expense===undefined||item.expense.amount===undefined||item.expense.amount===null?'':this.getNumberFormat(item.expense.amount)}</td>
              <td className='text-right'>{item.balance===undefined||item.balance===null?'':this.getNumberFormat(item.balance)}</td>
            </tr>
          )
        })
      )  
    }      
  }

  renderTable() {
    let {affiliates} = this.state
    
     return(
      <div className='display-overflow'>
        <table className='table table-responsive table-hover table-bordered-solid table-report-kkc-all-year-income-overview' style={{width:'2100px'}}>
          <thead>
            <tr>
              <th colSpan={12+affiliates.length} className='text-center bg-none'>สรุปรายรับรถเข้าซ่อม - ค่าใช้จ่าย {this.state.year}</th>
            </tr>
            <tr>
              <th rowSpan={2} className='text-center bg-none' style={{width:'50px'}}>ลำดับ</th>
              <th className='text-center bg-none' colSpan={2+affiliates.length}>รถเข้าซ่อม</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>รวมรายได้</th>
              <th className='text-center bg-none' colSpan={4}>คชจ.</th>
              <th rowSpan={2} className='text-center bg-none' style={{width:'100px'}}>รวม คชจ.</th>
              <th className='text-center bg-none'>คงเหลือ</th>
            </tr>
            <tr>
              <th className='text-center bg-none' style={{width:'90'}}>เดือน</th>
              <th className='text-center bg-none' style={{width:'100'}}>ลูกค้า</th>
              {
                 affiliates.map((item,index)=>(
                  <th key={index} className='text-center bg-none' style={{width:'100'}}>{item.name}</th>
                ))
              }
              <th className='text-center bg-none' style={{width:'100'}}>ค่าแรง</th>
              <th className='text-center bg-none' style={{width:'100'}}>อะไหล่ต้นเดือน</th>
              <th className='text-center bg-none' style={{width:'100'}}>อะไหล่กลางเดือน</th>
              <th className='text-center bg-none' style={{width:'100'}}>เงินสด</th>
              <th className='text-center bg-none' style={{width:'100'}}>(รถเข้าซ่อม-คชจ.)</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th className='bg-none'></th>
              <th className='text-center bg-none'>รวมทั้งสิ้น</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('income','customer'))}</th>
              {
                 affiliates.map((item,index)=>(                  
                  <th key={index} className='text-right bg-none'>{this.getNumberFormat(this.getSummary('income',item.affiliates_id))}</th>
                ))
              }
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('income','amount'))}</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('expense','wage'))}</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('expense','part'))}</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('expense','part_midmonth'))}</th>              
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('expense','cash'))}</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('expense','amount'))}</th>
              <th className='text-right bg-none'>{this.getNumberFormat(this.getSummary('balance',''))}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )      
  }

  renderBarChat() {
    return(
      <div>
        <canvas 
          ref={(canvasBar) => { this.canvasBarRef = canvasBar; }}>
        </canvas>
      </div>
    )
  }

  onChartChange(key,value) {
    let {isPrice,isCost} = this.state
    if (value)
      value = false
    else 
      value = true

    if (key==='cost') 
      isCost = value
    else
      isPrice = value

    this.setState({isCost:isCost,isPrice:isPrice})
    this.setBarChart(isCost,isPrice)
  }

  render() {
    let {loading,data} = this.state

    if (this.props.showPrintPreview) { 
      if (this.props.typePrint==='chart') {
        if (data.length===0) {
          return(
            <div className='font-print'>
              <header className="text-center">
                <h2>ไม่พบข้อมูล</h2>
              </header>
            </div>
          )
        } else {
          return(
            <div className='font-print'>
              <header style={{textAlign:'center',marginBottom:'20px'}}>
                <h2>{this.props.titleBarChat}</h2>
              </header>
              <div className='font-14'>   
                {this.renderBarChat()}          
              </div>
            </div>  
          )
        } 
      }
    } else {
      return(
        <Box>
          <Box.Header border={true}>          
            <Box.Title>{this.props.renderMenu()}</Box.Title>
            <Box.Tools >
              <Button                 
                bsStyle={'link'} className='bg-maroon'
                onClick={this.onPrintClick.bind(this)}
              >
                <FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร
              </Button>                           
            </Box.Tools>
          </Box.Header>
          <Box.Body>
            {this.renderToolbar()}
            <div style={{display:this.state.displayTb}}>
              {this.renderTable()}
            </div>
            <div style={{display:this.state.displayBar}}>
              <Form inline>
                <FormGroup>
                  <Checkbox
                    onChange={this.onChartChange.bind(this,'cost',this.state.isCost)}
                    checked={this.state.isCost}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' แสดงค่าใช้จ่าย'}
                  >
                  </Checkbox>
                </FormGroup>
                &nbsp;
                <FormGroup>
                  <Checkbox
                    onChange={this.onChartChange.bind(this,'price',this.state.isPrice)}
                    checked={this.state.isPrice}
                    checkboxClass="icheckbox_square-blue"
                    increaseArea="20%"
                    label={' แสดงรายได้'}
                  >
                  </Checkbox>
                </FormGroup>
              </Form>
              {this.renderBarChat()}
            </div>
            <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
          </Box.Body>
        </Box>
      )
    }  
  }
} 

ReportKKCAllYearIncomeOverview.defaultProps = {
  show : false
}

export default ReportKKCAllYearIncomeOverview; 


// WEBPACK FOOTER //
// ./src/view/report/ReportKKCAllYearIncomeOverview.js